import * as React from 'react'
import { HiddenField } from 'react-rails-form-helpers'
import { Customer } from '../Customer'
import * as API from '../lib/api'

interface IProps {
  address: API.IAddress
  addressType: string
  signedIn: boolean
  customer: API.ICustomer
  toggleUseDefaultBillingAddress: () => void
}

export class Address extends React.Component<IProps, object> {
  public isUSA() {
    const { address } = this.props
    const { country } = address

    return country === 'USA'
  }

  public stateOrProvince() {
    const { address } = this.props
    const { state, province } = address

    return (this.isUSA() ? state : province)
  }

  public render() {
    const { signedIn, customer, address, addressType, toggleUseDefaultBillingAddress } = this.props
    const {
      address1,
      address2,
      city,
      zip,
      country,
    } = address

    return (
      <section className="address-form">
        <h2>Account Information</h2>

        <p>
          {signedIn ? <Customer customer={customer} /> : null}
          {address1}<br />
          {!!address2 ? address2 : null}
          {!!address2 ? <br /> : null}
          {city}, {this.stateOrProvince()} {zip}<br />
          {this.isUSA() ? '' : country}
        </p>

        <HiddenField name={`use_default_${addressType}_address`} value={true} />

        <a onClick={toggleUseDefaultBillingAddress}>Edit Billing Address</a>
      </section>
    )
  }
}
